import { Component, EventEmitter, Input, Output, SimpleChanges, inject, DestroyRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationBoxComponent } from 'src/app/shared/components/confirmation-box/confirmation-box.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'service-faqs',
    templateUrl: './service-faqs.component.html',
    styleUrl: './service-faqs.component.scss',
    standalone: false
})
export class ServiceFaqsComponent {
  private destroyRef = inject(DestroyRef);

  @Input() items: any = {};
  questionValue: string = '';
  answerValue: string = '';
  tableItems: any[] = [];
  counter = 1;
  deleteDialogRef: MatDialogRef<ConfirmationBoxComponent>;

  @Output() values = new EventEmitter<any>();

  constructor(private dialog: MatDialog) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['items'] && this.items) {
      const arr = Array.isArray(this.items) ? this.items : [];
      this.tableItems = arr
        .filter(value => value !== null && value !== undefined && value !== '')
        .map((value, i) => ({ order: i + 1, isEditing: false, question: value.question, answer: value.answer }));
      this.counter = this.tableItems.length + 1;
    }
  }

  add() {
    if (!this.questionValue?.trim() || !this.answerValue?.trim()) return;

    const newItem = {
      order: this.counter++,
      isEditing: false,
      question: this.questionValue,
      answer: this.answerValue
    };

    this.tableItems.push(newItem);
    this.emitAll();
    this.questionValue = '';
    this.answerValue = '';
  }

  emitAll() {
    const valuesArray = this.tableItems.map(item => {
      const { isEditing, ...clean } = item;
      return clean;
    });
    this.values.emit(valuesArray);
  }

  edit(item) {
    item.isEditing = true;
  }

  save(item) {
    item.isEditing = false;
    this.emitAll();
  }

  delete(index) {
    const item = this.tableItems[index];
    this.showDeleteConfirmationBox(item.index, index);
  }

  showDeleteConfirmationBox(id: number, index: number) {
    this.deleteDialogRef = this.dialog.open(ConfirmationBoxComponent, {
      data: {
        id,
        index,
        message: `هل أنت متأكد من الحذف؟`
      }
    });

    this.deleteDialogRef.afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(result => {
      if (result) {
        this.tableItems.splice(index, 1);
        this.emitAll();
      }
    });
  }
}
